import React from 'react';
import { COMMENT_BOX_PLACEHOLDER_TEXT } from '../../../../common/constants/data-hooks';
import { getIsMobile } from '../../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../../api-provider';
import { TooltipLazy } from '../../tooltip-lazy/tooltip-lazy';
import { st, classes } from './placeholder-text.st.css';
export const PlaceholderText = ({ text }) => {
    /*
        we want to use this component in SSR, so use dynamic tooltip chunk only
        after user hovers to avoid hydration issues
    */
    const [isTooltipUsed, setIsTooltipUsed] = React.useState(false);
    const Component = isTooltipUsed ? TooltipLazy : 'div';
    const containerNode = React.useRef(null);
    const textNode = React.useRef(null);
    const isTooltipEnabled = React.useRef(false);
    const isMobile = useApi(getIsMobile);
    React.useEffect(() => {
        if (containerNode.current &&
            textNode.current &&
            containerNode.current.getBoundingClientRect().width <
                textNode.current.getBoundingClientRect().width) {
            isTooltipEnabled.current = true;
        }
    }, [text]);
    return (React.createElement(Component, { className: st(classes.root, { isMobile }), content: React.createElement("div", { className: classes.tooltip }, text), disabled: !isTooltipEnabled.current, showDelay: 400, minWidth: 400, placement: "top-start", flip: true },
        React.createElement("div", { ref: containerNode, className: classes.textContainer, onMouseOver: () => setIsTooltipUsed(true) },
            React.createElement("span", { className: classes.comparisonNode, ref: textNode }, text),
            React.createElement("span", { "data-hook": COMMENT_BOX_PLACEHOLDER_TEXT }, text))));
};
//# sourceMappingURL=placeholder-text.js.map